import { motion } from "framer-motion";

export default function Battery() {
  return (
    <section
      className="relative py-20 px-6 text-white"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(249,122,8,0.3) 100%), url('/assets/s1.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* CONTENT WRAPPER */}
      <div className="max-w-6xl mx-auto">
        {/* 🔥 Heading */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-orange-400 mb-4">
            Battery Storage Solutions 🔋
          </h2>

          <p className="text-white/80 max-w-2xl mx-auto leading-relaxed">
            Power your future with SolidEra Energy. We provide reliable,
            efficient, and high-performance battery storage solutions for homes
            and businesses. Store excess energy, ensure uninterrupted power
            supply, and stay protected from load shedding with smart backup
            systems.
          </p>
        </motion.div>

        {/* 🔥 SECTIONS */}
        <div className="space-y-24">
          {[
            {
              title: "Lithium-ion Battery Systems",
              desc: `Lithium-ion battery systems are the most advanced energy storage solution available today. 
They provide high efficiency, fast charging, and longer life cycles compared to traditional batteries. 
These batteries are ideal for modern solar systems where performance and reliability are critical.`,
              img: "/assets/products/Lithium.jpeg",
            },
            {
              title: "Tubular Battery Solutions",
              desc: `Tubular batteries are known for their durability and cost-effectiveness. 
They provide strong backup support for homes and businesses. 
Ideal for areas with frequent load shedding and long power outages.`,
              img: "/assets/products/tubular.jpg",
            },
            {
              title: "Hybrid Battery Storage",
              desc: `Hybrid battery storage combines solar energy with grid electricity. 
Ensures uninterrupted energy supply with smart switching. 
Perfect for modern smart homes and businesses.`,
              img: "/assets/products/hybrid.jpg",
            },
            {
              title: "Industrial Battery Systems",
              desc: `Industrial battery systems are designed for heavy-duty usage. 
They support factories and commercial setups. 
Ensure smooth operations without downtime.`,
              img: "/assets/products/industrialbattery.jpg",
            },
            {
              title: "Battery Maintenance Services",
              desc: `Regular inspection and servicing improve battery performance. 
Prevents unexpected failures and increases lifespan. 
Ensures safe and reliable operation.`,
              img: "/assets/products/maintenance.jpg",
            },
            {
              title: "Energy Backup Solutions",
              desc: `Energy backup systems provide uninterrupted power supply. 
Essential for homes and industries. 
Ensure continuous performance during outages.`,
              img: "/assets/products/backup.jpg",
            },
          ].map((item, i) => {
            const isReverse = i % 2 !== 0;

            return (
              <div key={i} className="grid md:grid-cols-2 gap-10 items-center">
                {/* IMAGE */}
                <motion.div
                  initial={{ opacity: 0, x: isReverse ? 50 : -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className={`${isReverse ? "md:order-2" : ""} overflow-hidden rounded-2xl`}
                >
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-[320px] object-cover hover:scale-110 transition duration-500 rounded-2xl shadow-[0_0_30px_rgba(249,115,22,0.2)]"
                  />
                </motion.div>

                {/* TEXT */}
                <motion.div
                  initial={{ opacity: 0, x: isReverse ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className={`${isReverse ? "md:order-1" : ""}`}
                >
                  <div className="bg-black/40 backdrop-blur-md p-6 rounded-xl border border-orange-500/20 hover:border-orange-400 hover:shadow-[0_0_25px_rgba(249,115,22,0.4)] transition">
                    <h3 className="text-2xl font-bold text-orange-400 mb-4">
                      {item.title}
                    </h3>

                    <p className="text-white/80 leading-relaxed whitespace-pre-line">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
